import React, { useState } from 'react';
import Webcam from "react-webcam"

interface IProps {
    imageUpdated: any;
    image: string | null;
}


export default function CameraComponent(props: IProps) {
    const [image, setImage] = useState<string | null>();
    const [firstLoad, setFirstLoad] = useState(true);
    const webcamRef = React.useRef<Webcam>(null);

    const capture = React.useCallback(
        () => {
            console.log("Taking Picture")
            var webcam = webcamRef.current;
            if (webcam != null) {
                var image = webcam.getScreenshot();
                setImage(image)
                props.imageUpdated(image);
            }
        },
        [webcamRef]
    );

    const updateImage = () => {
        return image;
    }
    if(firstLoad && !image && props.image)
    {
        setFirstLoad(false);
        setImage(props.image);
    }
    const retakeImage = () => setImage(null);
    return (
        <div className="row col-6">
            <div className="col my-auto align-content-centre text-center">
                <h4>or upload a photo...</h4>
                <br />
                {image == null ?
                    <button type="button" onClick={capture} className="btn btn-lg btn-light">Take Picture</button> :
                    <button type="button" onClick={retakeImage} className="btn btn-lg btn-light">Retake Picture</button>
                }
            </div>
            <div className="col">
                {image == null ?
                    <Webcam audio={false} height={240} width={240} screenshotFormat="image/jpeg" ref={webcamRef} /> :
                    <div className="align-content-centre" style={{ height: 240, width: 240 }}><img className="my-auto" src={`data:image/jpeg;${image}`}></img></div>
                }
            </div>
        </div>)
}